import { useQuery } from "@tanstack/react-query";
import { makeApiRequest } from "../../utils";
import { SUPPORT_CATEGORIZED_TRANSACTIONS_QUERY_KEY } from "../../../constants/queryKeys";

export const useCategorizedTransactions = ({
  userId,
  page = 1,
  pageSize = 25,
  transactionId
}) => {
  const searchParams = new URLSearchParams({
    page,
    pageSize,
    ...(transactionId ? { transactionId } : {})
  }).toString();

  return useQuery({
    queryKey: [
      SUPPORT_CATEGORIZED_TRANSACTIONS_QUERY_KEY,
      userId,
      page,
      pageSize,
      transactionId
    ],
    queryFn: async () => makeApiRequest({
      endpoint: `/api/support/categorized-transactions/${userId}?${searchParams}`,
      method: "GET"
    }),
    enabled: !!userId,
    keepPreviousData: true
  });
};
